import { actionCreatorFactory } from 'typescript-fsa'

const actionCreator = actionCreatorFactory()

export const login = actionCreator<{ userId: string; isAdmin: boolean }>(
  'login',
)
export const logout = actionCreator('logout')
export const loginFailed = actionCreator('loginFailed')
